import { useMemo } from 'react';
import { Rive } from '@rive-app/react-canvas';

export function isInOldRiveFormat(rive: Rive | null) {
  // if a rive file has a run1 text run, then it needs to get text the old way
  // regardless if there is a view model instance or not
  return rive?.getTextRunValue('run1') !== undefined;
}

// Queries a Rive state machine's inputs exactly once per rive instance.
// Calling rive.stateMachineInputs(name) concurrently from multiple
// independent hook instances for the same state machine (e.g. one for the
// animation's own trigger input, another for a settings-driven button)
// crashes the tab — confirmed by isolating it from every other Rive API
// surface. Callers should look up the specific named input(s) they need
// from this single shared list instead of calling stateMachineInputs
// themselves.
export function useStateMachineInputs(
  rive: Rive | null,
  stateMachineName: string
): ReturnType<Rive['stateMachineInputs']> {
  return useMemo(() => {
    if (!rive) return [];
    try {
      return rive.stateMachineInputs(stateMachineName) || [];
    } catch {
      return [];
    }
  }, [rive, stateMachineName]);
}
